import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";

export const handleSubmit = async (
  newEmail: string,
  memberDetails: any,
  setLoading: (value: React.SetStateAction<boolean>) => void,
  setShowModal: (value: React.SetStateAction<boolean>) => void,
  setUploadError: (value: React.SetStateAction<boolean>) => void,
  setMessage: (value: React.SetStateAction<string>) => void
) => {
  setLoading(true);

  try {
    const payload = {
      newEmail,
      memberId: memberDetails.id,
      currentEmail: memberDetails.email,
      loyaltyId: memberDetails.loyaltyId,
    };
    const axiosResponse = await axios.put(
      process.env.REACT_APP_API_URL + APIConstants.update_email,
      payload
    );
    setShowModal(true);
    setUploadError(false);
    setMessage(axiosResponse?.data?.data?.message);
  } catch (error: any) {
    setUploadError(true);
    setShowModal(true);
    setMessage(error?.response?.data?.error);
  } finally {
    setLoading(false);
  }
};
